<template>
  <div class="wt2-confirm wt2-text-m wt2-thumbnail-panel">
    <wt-close @click.native="no"></wt-close>
    <div>{{ message }}</div>
    <div class="-actions-buttons">
      <span @click="no" class="no">{{ 'generic.NO' | culture }}</span>
      <span @click="yes" class="wt2-color-primary yes">{{
        'generic.YES' | culture
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: { type: String, required: true },
  },

  methods: {
    yes() {
      this.$emit('yes');
    },
    no() {
      this.$emit('no');
    },
  },
};
</script>
